import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/fileRecord/page', data, {
    trim: true
  })
}
